// Store
import { useStoreActions } from '@src/store/store';

type TClearBufferPointIds = (payload?: void) => void;

export function useClearBufferPointIds(): TClearBufferPointIds {
  return useStoreActions((actions): TClearBufferPointIds => actions.points.clearBufferPoints);
}
